import { container, title } from "../../nextjs-material-kit.js";

const landingPageStyle = (theme) => ({
  container: {
    zIndex: "12",
    color: "#ffffff",
    height: "auto",
    margin: "0 auto !important",
    marginBottom: "0",
    ...container(theme),
  },

  title: {
    ...title,
    display: "inline-block",
    position: "relative",
    marginTop: "30px !important",
    minHeight: "32px",
    color: "#FFFFFF",
    textDecoration: "none",
    fontFamily: "var(--font-brandon-grotesque)",
    fontWeight: 900,
    fontSize: "5.5em",
    left: "50%",
    transform: "translateX(-50%)",
  },
  inputField: {
    border: "1px solid #a4b9c2",
  },
  search_section: {
    padding: "20px 30px",
  },
  subtitle: {
    fontSize: "1.313rem",
    maxWidth: "500px",
    margin: "10px auto 0",
  },
  main: {
    position: "relative",
    zIndex: "3",
    marginBottom: "2rem",
  },
  bg_colored: {
    backgroundColor: "#eaf6fe",
  },
  darkBlue: {
    backgroundColor: "#095a70",
  },
  lightGreen: {
    backgroundColor: "#095a70",
    paddingTop: "7px !important",
    paddingBottom: "7px !important",
    marginTop: "25px",
  },
  colored_bg: {
    background: "#eaf6fe",
    padding: "50px 0",
    minHeight: "280px",
  },
  white_bg: {
    background: "#ffffff",
  },
});

export default landingPageStyle;
